
import {
  FilePlus2, 
  LayoutDashboard, 
  ShoppingBag, 
  Inbox, 
  TableProperties, 
  Calendar,
  BarChart3,
  Users,
  Crown,
  Store,
  Package,
  Truck,
  Share2
} from 'lucide-react';
import { NavItem } from './types';

export const navItems: NavItem[] = [
  {
    id: 'dashboard',
    label: 'Tableau de bord',
    icon: <LayoutDashboard className="h-5 w-5" />,
  },
  {
    id: 'social-media',
    label: 'Social Media',
    icon: <Share2 className="h-5 w-5" />,
    isExpandable: true,
    isExpanded: true,
    children: [
      { id: 'profiles', label: 'Boîte de réception', icon: <Inbox className="h-5 w-5" /> },
      { id: 'calendar', label: 'Calendrier', icon: <Calendar className="h-5 w-5" /> },
      { id: 'content', label: 'Contenu', icon: <TableProperties className="h-5 w-5" /> },
      { id: 'reports', label: 'Rapport', icon: <BarChart3 className="h-5 w-5" /> }
    ]
  },
  {
    id: 'online-store',
    label: 'Online Store',
    icon: <Store className="h-5 w-5" />,
    isExpandable: true,
    isExpanded: true,
    children: [
      { id: 'products', label: 'Produits', icon: <Package className="h-5 w-5" /> },
      { id: 'customers', label: 'Clients', icon: <Users className="h-5 w-5" /> },
      { id: 'orders', label: 'Commandes', icon: <Truck className="h-5 w-5" /> }
    ]
  },
];
